import { registerSW } from 'virtual:pwa-register';
import type RootStore from './stores/RootStore';
import type ServiceStore from 'stores/ServiceStore';

export function permissionRequest() {
  return new Promise(function (resolve, reject) {
    const permissionResult = Notification.requestPermission(function (result) {
      resolve(result);
    });

    if (permissionResult) {
      permissionResult.then(resolve, reject);
    }
  })
    .then(function (permissionResult) {
      console.log('permissionResult', permissionResult);
      if (permissionResult !== 'granted') {
        console.error("We weren't granted permission.");
      }
    })
    .catch((err: any) => {
      console.error('Something went wrong with permissionRequest.', err);
    });
}

export const pwaRegistration = (rootStore: RootStore) => {
  try {
    const updateSW = registerSW({
      onNeedRefresh() {
        console.log('onNeedRefresh');
        console.log('onNeedRefresh updateSW', updateSW);
        if (rootStore?.viewStore) {
          rootStore.viewStore?.setAppUpdateFound(true);
        }
      },
      onOfflineReady() {
        console.log('onOfflineReady');
        console.log('onOfflineReady updateSW', updateSW);
      },
      onRegisteredSW(swPath: string, registration: ServiceWorkerRegistration) {
        console.log('onRegisteredSW swPath', swPath);
        if (rootStore?.viewStore) {
          rootStore.viewStore?.setSwRegistration(registration);
        }
      },
      onRegisterError(err: unknown) {
        // Handle InvalidStateError gracefully in development
        if (err instanceof Error && err.name === 'InvalidStateError') {
          console.warn('Service Worker in invalid state (likely dev environment), skipping registration');
          return;
        }
        console.warn('Service Worker Error', err);
        if (rootStore?.logStore) {
          const logStore = rootStore.logStore as ServiceStore;
          logStore
            .create({
              message: 'Error Creating Service Worker',
              level: 'error',
              payload: err,
            })
            .catch((err: any) => {
              console.error('Error', err);
            });
        }
      },
    });
    if (rootStore?.viewStore && updateSW) {
      rootStore.viewStore.setSWUpdater(updateSW);
    }
    return 'Successfully Registered';
  } catch (err) {
    console.warn(
      'Something went wrong trying to register a serviceWorker',
      err
    );
  }
};
